<div class="app-login">
    <div class="body-app mt-3 mb-3">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <div class="content-app">
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-2 col-sm-12 col-12">
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-12">
                        <div class="card card-login">
                            <div class="card-body">
                                <a class="d-block mt-1 mb-1 mx-auto" style="max-width: 400px;" [routerLink]="['/home']">
                                    <img src="assets/Images/logo.jpg" class="img-fluid" alt="logo" />
                                </a>
                                <h5 class="mt-1 mb-1 text-center">
                                    <i class="fa-solid fa-circle-user"></i>
                                    Iniciar Sesión
                                </h5>
                                <hr class="mt-2 mb-3" />
                                <form [formGroup]="form">

                                <div class="form-group mb-3">
                                    <label>Usuario</label>
                                    <div>
                                        <input formControlName="userName" type="text" class="form-control" />
                                    </div>
                                </div>
                                <div class="form-group mb-3">
                                    <label>Contraseña</label>
                                    <div class="input-group">
                                        <input formControlName="password"
                                            [attr.type]="showPassword() ? 'text' : 'password'" class="form-control" />
                                        <button (click)="showPassword.set(!showPassword())" type="button"
                                            class="btn btn-primary">
                                            @if (showPassword()) {
                                            <i class="fa-solid fa-eye-slash"></i>
                                            }@else {
                                            <i class="fa-solid fa-eye"></i>
                                            }
                                        </button>
                                    </div>
                                </div>
                            </form>
                                <div class="mt-3 mb-2">
                                    <button (click)="login()" type="button" class="btn btn-primary w-100"
                                    [disabled]="isLoading()">
                                        @if (!isLoading()) {
                                            <i class="fa-solid fa-right-to-bracket"></i>
                                        }@else {
                                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        }
                                        Iniciar Sesión
                                    </button>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-sm-12 col-12">
                                        <a [routerLink]="['/ForgotUser']"  class="btn btn-secondary d-block w-100 mt-2 mb-0">
                                            <i class="fa-regular fa-address-card"></i>
                                            ¿Olvidó su usuario?
                                        </a>
                                    </div>
                                    <div class="col-md-6 col-sm-12 col-12">
                                        <div class="text-end">
                                            <a [routerLink]="['/ForgotPassword']" class="btn btn-secondary d-block w-100 mt-2 mb-0">
                                                <i class="fa-solid fa-key"></i>
                                                ¿Olvidó su contraseña?
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <a [routerLink]="['/home/register']" class="btn btn-outline-primary d-block w-100">
                                            <i class="fa-solid fa-user-plus"></i>
                                            Crear una cuenta nueva
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>